import { z } from 'zod'

export const reorderIncomeTemplatesSchema = z.object({
  ids: z.array(z.string().guid()).min(1).max(100),
})

export type ReorderIncomeTemplatesDto = z.infer<typeof reorderIncomeTemplatesSchema>
